import React from 'react';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { ProductBanner } from '@yme/molecules/product-banner';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { CYCLE_DESCRIPTION, CYCLE_HEAD_TEXT, CYCLE_MAIN_TITLE, CYCLE_TEXT_INFO, } from './';
export const CycleSchemeBanner = (props) => {
    const { title = CYCLE_MAIN_TITLE, separatorText = CYCLE_HEAD_TEXT, description = CYCLE_DESCRIPTION, textInfo = CYCLE_TEXT_INFO, icon, bannerIcon, } = props;
    return (React.createElement(FlexWrapper, { flexDirection: "column", gap: INDENT.sm },
        React.createElement(ProductBanner, { headerTextNode: React.createElement(RegularTextLevel3, { color: colorCoreBlack900Base, weight: 500 }, title), separatorText: separatorText, description: description, icon: React.createElement(SVGIcon, { type: bannerIcon, size: ICON_SIZE.xs }) }),
        React.createElement(FlexWrapper, { alignItems: "center", flexDirection: "row", gap: INDENT.xxxs },
            icon && icon,
            textInfo && React.createElement(RegularTextLevel3, null, textInfo))));
};
